import React, { useRef, useState } from "react";
import { Button, Divider, Flex, Input, Text } from "@fluentui/react-northstar";
import {
    DividerStyle,
    Email,
    EmailLabel,
    ErrorOTP,
    InputContainer,
    OTPInput,
    OTPLabel,
    OTPRegeneration,
    WrapperDividerStyle,
} from "./index.style";
import Toast from "../../../../components/Alerts";

const FormOTP = ({
    otp,
    functions,
    inputRefs,
    disable_btn_verify_otp,
    mutations,
    count_down,
    hashed_mail,
    alert,
    error,
    errorMessage,
}) => {
    return (
        <Flex column gap="gap.medium">
            <Flex column>
                <EmailLabel content="Un email vous a été envoyé à l'adresse :" />
                <Email content={hashed_mail} weight="bold" />
            </Flex>
            {/* alert */}
            <Toast {...alert.toast} />
            {/* inputs */}
            <Flex column gap="gap.large">
                <Flex fill hAlign="center">
                    <OTPLabel content="Veuillez saisir le code reçu :" />
                </Flex>
                <Flex column>
                    <InputContainer vAlign="center">
                        {otp.map((digit, index) => (
                            <Flex key={index} vAlign="center">
                                <OTPInput
                                    key={index}
                                    ref={(ref) =>
                                        (inputRefs.current[index] = ref)
                                    }
                                    type="text"
                                    maxLength={1}
                                    value={digit}
                                    autoFocus={index === 0}
                                    onChange={(e) =>
                                        functions.handleChange(
                                            index,
                                            e.target.value
                                        )
                                    }
                                    onKeyDown={(e) =>
                                        functions.handleKeyDown(index, e)
                                    }
                                    inverted
                                    $error={error}
                                />
                                {index === 2 && (
                                    <WrapperDividerStyle>
                                        <DividerStyle />
                                    </WrapperDividerStyle>
                                )}
                            </Flex>
                        ))}
                    </InputContainer>
                    <Flex>{error && <ErrorOTP content={errorMessage} />}</Flex>
                </Flex>
                <Flex>
                    <Button
                        primary
                        content="Envoyer le code"
                        fluid
                        flat
                        disabled={disable_btn_verify_otp}
                        onClick={mutations.verify_otp.mutate}
                        loading={mutations.verify_otp.isLoading}
                    />
                </Flex>
            </Flex>
            {/* RE-generation code */}
            <Flex hAlign="center">
                <OTPRegeneration column gap="gap.smaller" fill>
                    <Text content="Aucun code reçu ?" />
                    <Flex hAlign="center">
                        <Button
                            content={`Générer un nouveau code ${
                                count_down.seconds
                                    ? `(${count_down.seconds}s)`
                                    : ""
                            }`}
                            flat
                            disabled={count_down.seconds}
                            onClick={mutations.generation_otp.mutate}
                            loading={mutations.generation_otp.isLoading}
                        />
                    </Flex>
                </OTPRegeneration>
            </Flex>
        </Flex>
    );
};

export default FormOTP;
